import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CorrespondenceTeamActions from './team.actions';
import { CorrespondenceTeamService } from '../../services/team.service';

@Injectable()
export class CorrespondenceTeamEffects {
  loadCorrespondenceTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceTeamActions.loadCorrespondenceTeam),
      exhaustMap((_) =>
        this.correspondenceTeamService.getCorrespondenceTeam().pipe(
          map((data) =>
            CorrespondenceTeamActions.loadCorrespondenceTeamSuccess({
              correspondenceTeam: data,
            })
          ),
          catchError((error) =>
            of(
              CorrespondenceTeamActions.loadCorrespondenceTeamFailure({ error })
            )
          )
        )
      )
    )
  );

  addCorrespondenceTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceTeamActions.addCorrespondenceTeam),
      concatMap(({ newCorrespondenceTeam }) =>
        this.correspondenceTeamService
          .createCorrespondenceTeam(newCorrespondenceTeam)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return CorrespondenceTeamActions.addCorrespondenceTeamSuccess({
                newCorrespondenceTeam: data,
              });
            }),
            catchError((error) =>
              of(
                CorrespondenceTeamActions.addCorrespondenceTeamFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateCorrespondenceTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceTeamActions.updateCorrespondenceTeam),
      map((action) => action.updateCorrespondenceTeam),
      concatMap((updateCorrespondenceTeam) =>
        this.correspondenceTeamService
          .updateCorrespondenceTeam(updateCorrespondenceTeam)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return CorrespondenceTeamActions.updateCorrespondenceTeamSuccess({
                updateCorrespondenceTeam: updateCorrespondenceTeam,
              });
            }),
            catchError((error) =>
              of(
                CorrespondenceTeamActions.updateCorrespondenceTeamFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeCorrespondenceTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceTeamActions.removeCorrespondenceTeam),
      map((action) => action.ids),
      concatMap((ids) =>
        this.correspondenceTeamService.deleteCorrespondenceTeam(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return CorrespondenceTeamActions.removeCorrespondenceTeamSuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              CorrespondenceTeamActions.updateCorrespondenceTeamFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private correspondenceTeamService: CorrespondenceTeamService,
    private notification: NotificationService
  ) {}
}
